import { DocIcon, PdfIcon } from '../../assets';

const DocumentListItem = ({ documentName }) => {
  return (
    <>
      {documentName?.match(/(?:\.([^.]+))?$/)[1] === 'pdf' && <PdfIcon size={30} />}
      {documentName?.match(/(?:\.([^.]+))?$/)[1] === 'docx' && <DocIcon size={30} />}
      <span>{documentName}</span>
    </>
  );
};

export default DocumentListItem;
